import(/* webpackMode: "eager" */ "/vercel/path0/app/chat/page.tsx");
